import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';

import { getCookie } from "@/utils/cookie";

export const Layout = () => import('@/layout/index.vue');

// 静态路由
export const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'Home',
        meta: {
          title: '首页'
        },
        component: () => import('@/view/home/index.vue')
      },
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/view/login/index.vue')
      },
      {
        path: '/user_center',
        name: 'UserCenter',
        meta: {
          title: '用户中心'
        },
        component: () => import('@/view/user_center/index.vue')
      },
      {
        path: '/data_status',
        name: 'DataStatus',
        component: () => import('@/view/data_status/index.vue')
      },
      {
        path: '/data_setting',
        name: 'DataSetting',
        component: () => import('@/view/data_setting/index.vue')
      },
      // {
      //   path: '404',
      //   component: () => import('@/views/error_page/404.vue')
      // },
      // {
      //   path: '403',
      //   component: () => import('@/views/error_page/403.vue')
      // }
    ]
  }
];
export const SYSTEM_ROUTES: RouteRecordRaw[] = [
  {
    path: '/System',
    name: 'SystemInit',
    meta: {
      title: '系统设置'
    },
    component: Layout,
    children: [
      {
        path: '/System/DepartmentManage',
        name: 'DepartmentManage',
        meta: {
          title: '部门管理'
        },
        component: () => import('@/view/system_setting/department_manage/index.vue')
      },
      {
        path: '/System/UserManage/',
        name: 'UserManage',
        meta: {
          title: '用户管理'
        },
        component: () => import('@/view/system_setting/user_manage/index.vue')
      },
      {
        path: '/System/RoleManage',
        name: 'RoleManage',
        meta: {
          title: '角色管理'
        },
        component: () => import('@/view/system_setting/role_manage/index.vue')
      },
      {
        path: '/System/MenuManage',
        name: 'MenuManage',
        meta: {
          title: '菜单管理'
        },
        component: () => import('@/view/system_setting/menu_manage/index.vue')
      },
      {
        path: '/System/DictManage',
        name: 'DictManage',
        meta: {
          title: '字典管理'
        },
        component: () => import('@/view/system_setting/dictionary_manage/index.vue')
      },
      {
        path: '/System/SysLog',
        name: 'SysLog',
        meta: {
          title: '日志管理'
        },
        component: () => import('@/view/system_setting/log_manage/index.vue')
      }
    ]
  }
];
export const PRODUCT_ROUTES: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/Product',
        name: 'Product',
        meta: {
          title: '产品中心'
        },
        component: () => import('@/view/product/product_manage/index.vue')
      },
      {
        path: '/Product/Settings',
        name: 'ProductSettings',
        meta: { title: '产品设置' },
        component: () => import('@/view/product/product_settings/index.vue')
      },
      {
        path: '/Product/Form',
        name: 'ProductForm',
        meta: {
          title: '产品编辑'
        },
        component: () => import('@/view/product/product_manage/productForm.vue')
      }
    ]
  }
];
export const TEMPLATE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/Template',
        name: 'TemplateManage',
        meta: {
          title: '设计模版管理'
        },
        component: () => import('@/view/template/template_manage/index.vue')
      }
    ]
  }
];

export const STUDIO_ROUTES: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/Studio',
        name: 'Studio',
        meta: {
          title: '影楼产品赋权管理'
        },
        component: () => import('@/view/studio_setting/studio_manage/index.vue')
      }
    ]
  }
];

export const PURCHASE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/Purchase',
        name: 'Purchase',
        meta: {
          title: '订单管理'
        },
        component: () => import('@/view/purchase_setting/purchase_manage/index.vue')
      }
    ]
  }
];

const INIT_ROUTES = [
  ...constantRoutes,
  ...SYSTEM_ROUTES,
  ...PRODUCT_ROUTES,
  ...TEMPLATE_ROUTES,
  ...STUDIO_ROUTES,
  ...PURCHASE_ROUTES,
];

/**
 * 创建路由
 */
const router = createRouter({
  history: createWebHistory(),
  routes: INIT_ROUTES as RouteRecordRaw[],
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 })
});

// 回登录页
export function goLogin() {
  const tenantCode = localStorage.getItem('tenantCode');
  router.push('/login/' + tenantCode);
}

// 路由守卫
router.beforeEach((to, _from, next) => {
  const token = getCookie("factory_user_token");
  if (to.name !== 'Login' && !token) {
    next({ name: 'Login' });
  } else {
    next();
  }
});


export default router;
